// A CONVERT FORM OPENED FROM AN UNBOOKED LINE (components/UnbookedTrades.tsx, 4 Nov 2026): `?to=` is the To asset and
// `?day=` the Dubai day whose fills the form presets once, as that day's Use button would. A day older than the form's
// own fills window widens the read back to that day, so the line's fills are there to preset. Both consoles' desk forms
// read it the same way.
import { sameAsset } from './naming';

export type ConvertPrefill = { to: string; day: string | null };

/** The To asset (one the form offers, never the From asset itself) and the day, from the URL; '' / null when absent. */
export function prefillOf(search: URLSearchParams, fromAsset: string, assets: readonly string[]): ConvertPrefill {
  const want = search.get('to') ?? '';
  const to = want && want !== fromAsset ? (assets.find((a) => a === want) ?? assets.find((a) => sameAsset(a, want)) ?? '') : '';   // dialect-ok: the exact code first, then its fold
  const d = search.get('day') ?? '';
  return { to, day: /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null };
}

const dayStart = (day: string): number => Date.parse(`${day}T00:00:00+04:00`);

/** Where the form's fills read starts: its own window, or the opened day's Dubai midnight when that is earlier. */
export function fillsFrom(days: number, day: string | null, now = Date.now()): string {
  const own = now - days * 24 * 3600 * 1000;
  return new Date(day ? Math.min(own, dayStart(day)) : own).toISOString();
}

/** True when the opened day lies before the form's own window (the panel then says "since <day>"). */
export function widened(days: number, day: string | null, now = Date.now()): boolean {
  return !!day && dayStart(day) < now - days * 24 * 3600 * 1000;
}
